/**
 * The active booth event lives in its own module for the same reason the auth
 * context does: the nav provides it while the record dialog deep in the till
 * consumes it, and importing from App would close an import cycle whose
 * evaluation order ESM does not guarantee.
 */

import { createContext } from 'react';

import type { EventSummary } from './client';

export type EventContextValue = {
  /** Every open event, as the nav picker and the record dialog need them. */
  events: EventSummary[];
  /** The event new sales are filed under, or null when none is selected. */
  activeEvent: EventSummary | null;
  setActiveEvent: (event: EventSummary | null) => void;
};

export const EventContext = createContext<EventContextValue>({
  events: [],
  activeEvent: null,
  setActiveEvent: () => undefined,
});
